import {
  createArrayValidator,
  createObjectValidator,
  validateNumber
} from "../../../../packages/validator/validator.js";
import { QueryItem, validateQueryItem } from "../query/QueryItem.js";

export type VatReturn = {
  /**
   * Total amount of VAT to be returned.
   */
  total: number;
  /**
   * Returned VAT from Estonian expenses.
   */
  expenses: number;
  /**
   * Returned VAT from reverse charge.
   */
  reverseCharged: number;
  /**
   * Items associated with the Estonian expenses.
   */
  expensesItems: QueryItem[];
  /**
   * Items associated with VAT reverse charge.
   */
  reverseChargedItems: QueryItem[];
};

export const validateVatReturn = createObjectValidator<VatReturn>("VatReturn", {
  total: validateNumber,
  expenses: validateNumber,
  reverseCharged: validateNumber,
  expensesItems: createArrayValidator(validateQueryItem),
  reverseChargedItems: createArrayValidator(validateQueryItem)
});
